import './ImageCheckbox.scss';
import React from 'react';
import cx from 'classnames';

type ImageCheckboxProps = {
    name?: string,
    className?: string,
    check: boolean,
    src?: string,
    label?: string,
    value?: string,
    onCheck?: (param: string) => void,
    error?: string,
}

const ImageCheckbox = ({
    className,
    check,
    src,
    label,
    value = '',
    onCheck = () => null,
    error,
    name,
}: ImageCheckboxProps) => (
    <div className={cx('b-image-checkbox', className)} onClick={() => onCheck(value)}>
        {src
            && <img src={src} alt={label} />
        }
        <div className="b-checkbox" data-testid={`checkbox-${name}`}>
            <div className={`box ${cx({ check, error })}`} />
            <div className="label">{label}</div>
        </div>
    </div>
);

export default ImageCheckbox;
